import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchBeatCustomers, fetchPlantVisit, uploadBeatCustomerVisitRemark } from 'Service/ApiService';
import { showSuccessAlert } from 'utils/SuccessMessage';
import { showAlert } from 'utils/ErrorMessage';
import { getPositionsForBeat } from 'utils/constants';

const BeatsController = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [beatCustomers, setBeatCustomers] = useState([]);
  const [cloading, setCloading] = useState(false);
  const [customerCount, setCustomerCount] = useState(0);
  const [route, setRoute] = useState('');
  const [openStatusModal, setOpenStausModal] = useState(false);
  const [remark, setRemark] = useState('');
  const [statusCustomer, setStatusCustomer] = useState({});

  const location = useLocation();
  const { beatCode, selectedDate } = location.state || {};
  const today = new Date();
  const selected = new Date(selectedDate);
  const isPastDate = selected < new Date(today.toDateString());

  const [selectedPlant, setSelectedPlant] = useState('');
  const [userType, setUserType] = useState('');
  const [plantOptions, setPlantOptions] = useState([]);
  const [isPlantVisit, setIsPlantVisit] = useState(false);
  const [plantError, setPlantError] = useState(false);
  const handlePlantChange = (event) => {
    setPlantError(false);
    setSelectedPlant(event.target.value);
  };

  useEffect(() => {
    getBeatCustomers();
    getPlantVisitData();
  }, []);

  useEffect(() => {
    console.log(statusCustomer);
  }, [statusCustomer]);

  const getBeatCustomers = async () => {
    try {
      setCloading(true);

      const response = await fetchBeatCustomers(beatCode, user.userCode);

      if (response) {
        if (response.success == true) {
          setCustomerCount(response.data.length ?? 0);
          setRoute(response.data[0].beat_description ?? '');
          setBeatCustomers(response.data);
          setCloading(false);
        } else {
          setCustomerCount(response.data.length ?? 0);
          setRoute(response.data[0].beat_description ?? '');
          setBeatCustomers(response.data);
          setCloading(false);
        }
      }
    } catch (error) {
      setCloading(false);
      console.error('Error fetching beats:', error);
    }
  };

  const showCustomerReports = (customerData) => {
    navigate(`/beat-customer-reports`, { state: { customer: customerData } });
  };

  const showCustomerMReports = () => {
    navigate(`/beat-m-report`);
  };

  const toggleStatusModal = (customer, plantVisit = false, userType = 'customer') => {
    setStatusCustomer(openStatusModal ? {} : customer);
    setSelectedPlant('');
    setIsPlantVisit(plantVisit);
    setUserType(userType);
    setOpenStausModal(!openStatusModal);
    setRemark('');
  };

  const changeRemark = (value) => {
    setRemark(value);
  };

  const sendVisitRemark = async (visitStatus) => {
    try {
      if (isPlantVisit && selectedPlant == '') {
        setPlantError(true);
        return;
      } else {
        setPlantError(false);
      }

      setCloading(true);
      const { latitude, longitude, address } = await getPositionsForBeat();
      const userCode = user.userCode;
      const partyCode = statusCustomer.party_code;
      const visitRemark = remark;
      const visitDate = getDate();

      const response = await uploadBeatCustomerVisitRemark(
        userCode,
        beatCode,
        partyCode,
        visitStatus,
        visitRemark,
        visitDate,
        latitude,
        longitude,
        address,
        selectedPlant,
        userType
      );

      if (response) {
        if (response.success == true) {
          toggleStatusModal();
          showSuccessAlert(response.msg, 'Message');
          setCloading(false);
        } else {
          showAlert('Remark not send!', 'Remark');
          setCloading(false);
        }
      }
    } catch (error) {
      setCloading(false);
      let errorMsg = '';
      switch (error.code) {
        case 1:
          errorMsg = 'User denied geolocation permission.';
          break;
        case 2:
          errorMsg = 'Location information is unavailable.';
          break;
        case 3:
          errorMsg = 'The request to get user location timed out.';
          break;
        default:
          errorMsg = 'An unknown error occurred.';
      }
      setOpenStausModal(false);
      showAlert(errorMsg, 'Geolocation error');
    }
  };

  const getDate = () => {
    const now = new Date();
    const visitDate =
      now.getFullYear() +
      '-' +
      String(now.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(now.getDate()).padStart(2, '0') +
      ' ' +
      String(now.getHours()).padStart(2, '0') +
      ':' +
      String(now.getMinutes()).padStart(2, '0') +
      ':' +
      String(now.getSeconds()).padStart(2, '0');
    return visitDate;
  };

  const getPlantVisitData = async () => {
    try {
      const response = await fetchPlantVisit();

      if (response && response.success === true) {
        const options = response.data.map((row) => ({
          value: row.plant_list_id,
          label: row.plant_list
        }));
        console.log(options);
        setPlantOptions(options);
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      showAlert(error);
    }
  };

  return {
    user,
    selectedDate,
    isPastDate,
    cloading,
    customerCount,
    route,
    beatCustomers,
    openStatusModal,
    toggleStatusModal,
    remark,
    changeRemark,
    showCustomerReports,
    showCustomerMReports,
    sendVisitRemark,
    selectedPlant,
    handlePlantChange,
    plantOptions,
    isPlantVisit,
    plantError
  };
};

export default BeatsController;
